<template>
  <el-dialog
    class="radish-dia"
    title="待跟进"
    top="70px"
    :modal="false"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form ref="form" :model="form" label-width="120px">
      <el-form-item class="is-required" label="跟进项">
        <el-radio v-model="form['跟进项']" label="电话沟通">电话沟通</el-radio>
        <el-radio v-model="form['跟进项']" label="索要简历">索要简历</el-radio>
        <el-radio v-model="form['跟进项']" label="人选会面">人选会面</el-radio>
        <el-radio v-model="form['跟进项']" label="提醒面试">提醒面试</el-radio>
        <el-radio v-model="form['跟进项']" label="沟通反馈">沟通反馈</el-radio>
      </el-form-item>
      <el-form-item class="is-required" label="提醒时间">
        <!-- <el-date-picker
          v-model="form['跟进时间']"
          type="datetime"
          placeholder="选择日期"
          format="yyyy-MM-dd HH:mm"
          size="small"
        >
        </el-date-picker> -->
        <div class="rde-actions">
          <el-button v-for="(time, k) in times" :key="k" size="mini" @click="setTime(time)">{{ time }}</el-button>
          <span>
            自定义：
            <el-date-picker
              v-model="form['跟进时间']"
              type="datetime"
              placeholder="选择日期"
              format="yyyy-MM-dd HH:mm"
              size="mini"
            >
            </el-date-picker>
          </span>
        </div>
      </el-form-item>
      <el-form-item label="备注"> <el-input v-model="form['备注']" type="textarea" :span="3"></el-input> </el-form-item>
      <el-form-item label="提醒">
        <el-select
          v-model="form['提醒']"
          multiple
          filterable
          size="small"
          placeholder="选择提醒对象"
          style="display: block"
        >
          <el-option v-for="(item, k) in users" :key="k" :label="item" :value="item"> </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" style="margin-right:5px" @click="dialogVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
const dateFormat = require('dateformat')

export default {
  props: {
    onConfirm: Function,
  },
  data: function() {
    return {
      dialogVisible: false,
      form: {},
      users: [],
      radish: {},
      times: [
        '一小时后',
        '两小时后',
        '三小时后',
        '四小时后',
        '五小时后',
        '晚上七点',
        '晚上八点',
        '明天上午九点',
        '明天下午两点',
      ],
    }
  },
  async created() {
    if (!app.accounts) {
      await app.getUsers()
    }
    this.users = app.accounts
  },
  methods: {
    show: function(radish) {
      this.radish = Object.assign({}, radish)
      this.form = {}
      this.dialogVisible = true
    },
    setTime(time) {
      let remindTime = null
      switch (time) {
        case '一小时后':
          remindTime = new Date(new Date().getTime() + 3600000)
          break
        case '两小时后':
          remindTime = new Date(new Date().getTime() + 3600000 * 2)
          break
        case '三小时后':
          remindTime = new Date(new Date().getTime() + 3600000 * 3)
          break
        case '四小时后':
          remindTime = new Date(new Date().getTime() + 3600000 * 4)
          break
        case '五小时后':
          remindTime = new Date(new Date().getTime() + 3600000 * 5)
          break
        case '晚上七点':
          remindTime = new Date(new Date(new Date().setHours(19)).setMinutes(0))
          break
        case '晚上八点':
          remindTime = new Date(new Date(new Date().setHours(20)).setMinutes(0))
          break
        case '明天上午九点':
          remindTime = new Date(new Date(new Date(new Date().getTime() + 3600000 * 24).setHours(9)).setMinutes(0))
          break
        case '明天下午两点':
          remindTime = new Date(new Date(new Date(new Date().getTime() + 3600000 * 24).setHours(14)).setMinutes(0))
          break
        default:
          break
      }
      this.form = Object.assign({}, this.form, { 跟进时间: remindTime })
    },
    async handleConfirm() {
      if (this.followLoading) return
      this.followLoading = true
      if (!this.form['跟进项']) {
        this.followLoading = false
        return this.$message.warning('请选择跟进项')
      }
      if (!this.form['跟进时间']) {
        this.followLoading = false
        return this.$message.warning('请选择跟进时间')
      }
      const me = app.user.account
      if (!this.form['提醒']) {
        this.form['提醒'] = [me]
      } else if (!this.form['提醒'].includes(me)) {
        this.form['提醒'].push(me)
      }
      this.radish.followTime = new Date(this.form['跟进时间']).valueOf()
      this.radish.notifyInfo = this.form
      try {
        await window.app.service('project').followUpsert(this.radish)
        this.$message({
          type: 'success',
          message: '操作成功',
        })
        try {
          window.app.root.$refs.followDrawer && window.app.root.$refs.followDrawer.loadData()
        } catch (error) {
          console.error(error)
        }
      } catch (error) {
        this.$message.error(error.message)
      }
      this.dialogVisible = false
      this.followLoading = false
    },
  },
}
</script>
